var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2772 5.1058V5.06291C24.2655 5.03308 24.2512 5.0044 24.2343 4.97712L24.2022 4.93423L24.1378 4.86453L24.1003 4.83236L24.0306 4.80019H24.0038L12.3584 0.039106C12.2295 -0.0130353 12.0853 -0.0130353 11.9563 0.039106L0.337779 4.71976H0.310971L0.241271 4.75193L0.20374 4.7841L0.1394 4.8538L0.107232 4.8967C0.0904097 4.92397 0.0760671 4.95266 0.0643387 4.98248V5.02537C0.058709 5.06988 0.058709 5.11491 0.0643387 5.15941C0.0643387 12.4995 0 12.2959 0 18.6438C0.00107232 18.8603 0.13223 19.0548 0.332417 19.137L11.9563 23.9625C12.0144 23.9855 12.0762 23.9982 12.1386 24C12.2011 23.9982 12.2628 23.9855 12.3209 23.9625L23.9448 19.137C24.145 19.0548 24.2762 18.8603 24.2772 18.6438V5.23984C24.2829 5.19534 24.2829 5.1503 24.2772 5.1058ZM12.3365 1.30929L16.0166 2.89147L6.35398 6.95069L2.49696 5.40553L12.3365 1.30929ZM11.4207 22.4885L1.2541 18.1028C1.2541 11.176 1.2541 15.8474 1.2541 6.20441L5.16856 7.89867L11.4207 10.5795V22.4885ZM12.1601 9.30979L7.92441 7.5351L17.5977 3.45979L21.9889 5.4109L15.9561 7.9099L12.1601 9.30979ZM12.8726 22.4885V10.5795L15.7094 9.32485L23.0339 6.19369L23.0607 18.1028L12.8726 22.4885Z",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownTicket);
export default __webpack_public_path__ + "static/media/dropdown-ticket.6f89a5e0645216371af51dc98c24698d.svg";
export { ForwardRef as ReactComponent };